<template>
  <div class="person-rate-container">
    <div class="sticky-search">
      <label for="salesman">业务员:</label>
      <input type="text" v-model="search.salesman" id="salesman" :disabled="disableSearch">

      <label for="startDate">开始日期:</label>
      <input type="date" v-model="search.startDate" id="startDate" :disabled="disableSearch">

      <label for="endDate">结束日期:</label>
      <input type="date" v-model="search.endDate" id="endDate" :disabled="disableSearch">

      <button @click="fetchData" :disabled="loading || disableSearch">{{ loading ? '查询中...' : '查询' }}</button>
    </div>

    <div class="hint-text">
      <label>提示:个人业务员的订单数据只能从2025.3.23起查询</label>
    </div>

    <table>
      <thead class="sticky-header">
        <tr>
          <th>业务员</th>
          <th>国家</th>
          <th>待揽收</th>
          <th>到件</th>
          <th>发件</th>
          <th>派送中</th>
          <th>退件中</th>
          <th>退件签收</th>
          <th>已签收</th>
          <th>总计</th>
          <th>签收率</th>
        </tr>
      </thead>
      <tbody>
        <!-- 加载中状态 -->
        <tr v-if="loading">
          <td colspan="11" style="text-align: center; padding: 20px;">
            <span v-if="$loading">
              <el-icon>
                <Loading />
              </el-icon> 加载中...
            </span>
            <span v-else>加载中...</span>
          </td>
        </tr>

        <!-- 错误状态 -->
        <tr v-else-if="error">
          <td colspan="11" style="text-align: center; padding: 20px; color: #f56c6c;">
            {{ error }}
          </td>
        </tr>

        <!-- 无数据状态 -->
        <tr v-else-if="!hasData">
          <td colspan="11" style="text-align: center; padding: 20px;">
            暂无数据
          </td>
        </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in filteredData" :key="item.idx">
          <td>{{ item.salesman || '-' }}</td>
          <td>{{ item.warehouse || '-' }}</td>
          <td>{{ item.waitCollectedNum || '-' }}</td>
          <td>{{ item.arrivedNum || '-' }}</td>
          <td>{{ item.dispatchedNum || '-' }}</td>
          <td>{{ item.deliveringNum || '-' }}</td>
          <td>{{ item.returningNum || '-' }}</td>
          <td>{{ item.returnSignedNum || '-' }}</td>
          <td>{{ item.signedNum || '-' }}</td>
          <td>{{ item.totalNum || '-' }}</td>
          <td>{{ item.signRateStr || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PersonRate',
  data() {
    // 设置默认日期范围（近一个月）
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 30);
    
    const formatDate = (date) => {
      return date.toISOString().split('T')[0];
    };

    return {
      search: {
        salesman: '',
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        warehouse: 'GH01',
        sku: ''
      },
      items: [],
      filteredData: [],
      loading: false,
      error: null,
      disableSearch: false
    };
  },
  computed: {
    hasData() {
      return this.filteredData && this.filteredData.length > 0;
    }
  },
  methods: {
    /**
     * 获取个人签收率数据
     */
    fetchData() {
      // 设置加载状态
      this.loading = true;
      this.error = null;

      // 构建请求URL
      const url = '/data-serv/sign-rate/person';

      // 创建取消令牌，用于在组件销毁时取消请求
      const CancelToken = this.axios.CancelToken;
      const source = CancelToken.source();
      this._axiosRequest = source;

      // 构建请求参数
      const params = {
        warehouse: this.search.warehouse,
        salesman: this.search.salesman,
        sku: this.search.sku,
        startDate: this.search.startDate,
        endDate: this.search.endDate,
        cancelToken: source.token
      };

      // 移除空值参数
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || key === 'cancelToken') {
          delete params[key];
        }
      });

      // 使用axios获取数据
      this.axios.get(url, { params })
        .then(response => {
          // 检查响应数据格式
          if (Array.isArray(response.data)) {
            this.items = response.data;
            this.filteredData = this.items;
          } else {
            throw new Error('无效的数据格式');
          }
        })
        .catch(error => {
          // 忽略取消请求的错误
          if (this.axios.isCancel(error)) {
            return;
          }

          console.error('获取数据失败:', error);
          this.error = error.message || '获取数据失败';

          // 显示错误提示
          if (this.$message) {
            this.$message.error(this.error);
          }

          // 清空数据
          this.items = [];
          this.filteredData = [];
        })
        .finally(() => {
          // 无论成功失败，都设置加载状态为false
          this.loading = false;
          this._axiosRequest = null;
        });
    }
  },
  mounted() {
    // 组件挂载时获取数据
    this.fetchData();
  },
  beforeDestroy() {
    // 取消可能正在进行的请求
    if (this._axiosRequest) {
      this._axiosRequest.cancel('组件已销毁');
    }
  }
}
</script>

<style scoped>
.person-rate-container {
  padding: 20px;
}

.sticky-search {
  top: 0px;
  position: sticky;
  background-color: white;
  z-index: 1001;
  padding-bottom: 10px;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}

.sticky-search label {
  margin-right: 5px;
  margin-left: 10px;
}

.sticky-search label:first-child {
  margin-left: 0px;
}

.sticky-search input {
  margin-right: 15px;
  padding: 5px;
}

.sticky-search button {
  padding: 5px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.sticky-search button:hover {
  background-color: #45a049;
}

.hint-text {
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
  padding: 10px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.sticky-header {
  position: sticky;
  top: 70px;
  background-color: white;
  z-index: 1000;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f5f5f5;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sticky-search {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .sticky-search label,
  .sticky-search input {
    margin-bottom: 10px;
    width: 100%;
  }

  .sticky-search button {
    width: 100%;
    margin-top: 10px;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th,
  td {
    padding: 6px 4px;
    font-size: 14px;
  }
}
</style>